<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const TimelineDefaults = {
        "name": "timeline",

        "meta": {
            "order": {
                "bullet-container": 1,
                "trail-line": 1.5,
                "icon-1": 2,
                "title-1": 4,
                "subtitle-1": 5,
                "icon-2": 6,
                "title-2": 8,
                "subtitle-2": 9,
                "icon-3": 10,
                "title-3": 12,
                "subtitle-3": 13,
                
            }
        },

        "outer-container": { 
            "style": {
                "padding-top": "0px",
                "padding-bottom": "0px",
                "align-items": "flex-start"
            }
        },

        "inner-container": {
            "style": {
                "flex-direction": "column",
                "align-items": "flex-start",
                "justify-content": "flex-start",
            }
        },

        "trail-lineContainer": {
            "name": "trail-lineContainer",
            "style": {
                "display": "flex",
                "flex-direction": "column",
                "align-items": "center",
                "justify-content": "center",
                "width": "30px",
                "height": "30px",
                "border-radius": "5px",
                "background-color": "#000000",
            }
        },

        "bullet-container": {
            "name": "bullet-container",
            "style": {
                "display": "flex",
                "flex-direction": "column",
                "align-items": "center",
                "justify-content": "center",
                "width": "30px",
                "height": "30px",
                "border-radius": "5px",
                "background-color": "#000000",
            }
        },

        "trail-line": {
            "name": "trail-line",
            "style": {
                "width": "8px",
                "min-height": "5px",
                "background-color": "#000000",
                "flex-grow": "100",
            },
        },

        "title-1": {
            "name": "title-1",
            "style": {
                "margin-top": "7px",
                "margin-left": "15px",
                "margin-bottom": "3px",
            },
            "innerText": "Day 1"
        },

        "subtitle-1": {
            "name": "subtitle-1",
            "style": {
                "margin-bottom": "7px",
                "margin-left": "15px",
            },
            "innerText": "Get access to all pro features"
        },

        "icon-1": {
            "name": "icon-1",
            "style": {
                "background-color": "#FFFFFF",
                "width": "16px",
                "height": "16px",

            },
            "custom": {
                "icon": {
                    "element": "icon",
                    "value": "bolt.fill",
                    "type": "icon",
                    "style": {
                        "-webkit-mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                        "mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                    }
                }
            }
        },

        "title-2": {
            "name": "title-2",
            "style": {
                "margin-top": "15px",
                "margin-left": "15px",
                "margin-bottom": "3px",
            },
            "innerText": "Day 5"
        },

        "subtitle-2": {
            "name": "subtitle-2",
            "style": {
                "margin-bottom": "15px",
                "margin-left": "15px",
            },
            "innerText": "Get a reminder about when your trial ends"
        },

        "icon-2": {
            "name": "icon-2",
            "style": {
                "background-color": "#FFFFFF",
                "width": "16px",
                "height": "16px",

            },
            "custom": {
                "icon": {
                    "element": "icon",
                    "value": "bell.badge.fill",
                    "type": "icon",
                    "style": {
                        "-webkit-mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                        "mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                    }
                }
            }
        },

        "title-3": {
            "name": "title-3",
            "style": {
                "margin-top": "7px",
                "margin-left": "15px",
                "margin-bottom": "3px",
            },
            "innerText": "Day 7"
        },

        "subtitle-3": {
            "name": "subtitle-3",
            "style": {
                "margin-bottom": "7px",
                "margin-left": "15px",
            },
            "innerText": "Get billed today, unless you cancel anytime before"
        },


        "icon-3": {
            "name": "icon-3",
            "style": {
                "background-color": "#FFFFFF",
                "width": "16px",
                "height": "16px",

            },
            "custom": {
                "icon": {
                    "element": "icon",
                    "value": "checkmark",
                    "type": "icon",
                    "style": {
                        "-webkit-mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                        "mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                    }
                }
            }
        }

    }

    
    
</script>

<script>

</script>


<div class="timeline-row">
    <div class="bullet-column">
        <div class="trail top"/>
        <div data-i-name="bullet-container">
            <div data-i-name="icon-1"/>
        </div>
        <div data-i-name="trail-line"></div>
    </div>

    <div>
        <h3 data-i-name="title-1"/>
        <p data-i-name="subtitle-1"/>
    </div>
</div>

<div class="timeline-row">
    <div class="bullet-column">
        <div data-i-name="trail-line"></div>
        <div data-i-name="bullet-container">
            <div data-i-name="icon-2"/>
        </div>
        <div data-i-name="trail-line"></div>
    </div>

    <div>
        <h3 data-i-name="title-2"/>
        <p data-i-name="subtitle-2"/>
    </div>
</div>

<div class="timeline-row">
    <div class="bullet-column">
        <div data-i-name="trail-line"></div>
        <div data-i-name="bullet-container">
            <div data-i-name="icon-3"/>
        </div>
        <div class="trail bottom"/>
    </div>

    <div>
        <h3 data-i-name="title-3"/>
        <p data-i-name="subtitle-3"/>
    </div>
</div>


<style>

.timeline-row {
    display: flex;
    align-items: stretch;
    justify-content: center;
}

.bullet-column {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-self: stretch;
}

.trail {
    width: 8px;
    min-height: 5px;
    background-color: rgba(0,0,0,0);
    flex-grow: 100;
}

</style>